import { Injectable } from '@angular/core';
import { DeviceType, IDeviceStore } from './device.types';

@Injectable({ providedIn: 'root' })
export class DeviceStore implements IDeviceStore {
  getDeviceType(): DeviceType {
    if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
      return 'mobile';
    }

    return 'desktop';
  }

  isMobileApp(): boolean {
    return this.isLegacyApp() || this.isCurrentApp();
  }

  isLegacyApp(): boolean {
    return /anotaaibot/i.test(navigator.userAgent);
  }

  isCurrentApp(): boolean {
    return /anotaaimobileapp/i.test(navigator.userAgent);
  }

  getApplication() {
    if (this.isMobileApp()) {
      if (this.isLegacyApp()) {
        return 'mobile_legacy';
      }
      return 'mobile_flutter';
    }
    return 'browser';
  }
}
